module.exports = __webpack_public_path__ + "static/media/image-share.9e95742c.svg";